module.exports = __webpack_public_path__ + "img/how_it_works_3.8991b2bd.png";